import React from "react";
import "./Hero.css";

const Hero = ({ imageSrc }) => {
  return (
    <div className="hero">
      <img src={imageSrc} alt="impresion 3D" className="hero__image" />
      <h1 className="hero__title">Tu Visión. Nuestra impresión.</h1>
    </div>
  );
};

export default Hero;
